import { cn } from '@hub-la/shadcn'
import { ImageIcon } from 'lucide-react'

export const Fallback = ({ isVideo = false }) => {
  return (
    <div
      data-testid="thumbnail-fallback"
      className={cn(
        'w-full h-full rounded flex justify-center items-center',
        isVideo ? 'bg-muted-foreground/10' : 'bg-gradient-to-t from-[rgba(49,64,0,0.6)] to-[rgba(216,255,95,0.6)]',
      )}
    >
      {isVideo && <ImageIcon className="w-6 h-6 text-muted-foreground" />}
    </div>
  )
}
